import React, { useEffect, useState } from "react";
import { Row, Container, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import BackArrow from "../../components/backArrow";
import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import UserItemShop from "../../components/UserShopItem/UserItemShop";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useGetShopByIdQuery, useGetShopItemsQuery } from "../../features/shop/shopApiSlice";
import { useCreateHelpMutation } from "../../features/user/userApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const Recycleuserprofile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { shopid: slugId } = useParams();
  const shopid = extractIdFromSlug(slugId);

  const { name } = useSelector((state) => state.user);
  const imageUrl = useSelector((state) => state.imgurl);

  // States
  const [lgShowreport, setLgShowreport] = useState(false);

  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    username: name?.fullname,
    imgurl: name?.imageUrl,
    problem: "",
    desciription: "",
    image: [""],
  });

  /* ======================
     Update image from redux
  ====================== */
  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  /* ======================
     RTK Query: Fetch Shop & Items
  ====================== */
  const { data: shopRes, isFetching: isShopLoading } = useGetShopByIdQuery(shopid, { skip: !shopid });
  const { data: itemsRes, isFetching: isItemsLoading } = useGetShopItemsQuery(
    { shopid, page: 1, limit: 15 },
    { skip: !shopid }
  );

  const [createHelp] = useCreateHelpMutation();

  const shopData = shopRes?.data?.Shop || null;
  const items = itemsRes?.regular || [];
  const loading = isShopLoading || isItemsLoading;

  /* ======================
     Report / Help Form
  ====================== */
  const PostShopDatas = async (e) => {
    e.preventDefault();

    try {
      const response = await createHelp(createShop).unwrap();
      if (response?.success) {
        setLgShowreport(false);
        setTimeout(() => {
          SuccessNotify("Form Recycle Shop Created Successfully");
          navigate(`/recycle-userprofile/${slugId}`);
        }, 1000);
      }
    } catch {
      FailedNotify("Failed To Create Shop");
    }
  };

  return (
    <Container>
      <Row>
        {/* ================= LEFT PROFILE ================= */}
        <Col lg="4" md="3" className="screenHeight">
          <div className="border b-radius height_100">
            {shopData ? (
              <UserShopProfile
                PostShopDatas={PostShopDatas}
                setCreateShop={setCreateShop}
                lgShowreport={lgShowreport}
                setLgShowreport={setLgShowreport}
                shopData={shopData}
                id={slugId}
                shopid={shopid}
              />
            ) : (
              <Skeleton height={400} />
            )}
          </div>
        </Col>

        {/* ================= RIGHT ITEMS ================= */}
        <Col lg="8" md="7" className="screenHeight">
          <div className="border b-radius">
            <div className="ms-3">
              <BackArrow back="/buy-retailer" />
            </div>
            {loading ? (
              <Skeleton count={5} height={120} style={{ marginBottom: "10px" }} />
            ) : (
              <UserItemShop
                back="/recycle-online"
                shopid={shopid}
                regular={items}
                newItemdata={items}
                shopData={shopData}
              />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Recycleuserprofile;
